// extracted by mini-css-extract-plugin
export default {"axnSessionsTableContainer":"axn-sessions-table-container__axn-sessions-table-container__xjsBw","axnSessionsTable":"axn-sessions-table-container__axn-sessions-table__GVhFx"};